<template>
  <v-layout row wrap>
    <v-flex lg3 xs12> </v-flex>
    <v-flex lg2 xs12>
      <v-text-field v-model="mainForm.coinsPer" :label="labels.coinsPer" readonly reverse :loading="loading"></v-text-field>
    </v-flex>
    <v-flex lg4 xs12>
      <v-text-field v-model="mainForm.coinsSI" :label="labels.coinsSI" readonly reverse :loading="loading"></v-text-field>
    </v-flex>
    <v-flex lg3 xs12> </v-flex>

    <v-flex lg3 xs12> </v-flex>
    <v-flex lg2 xs12> </v-flex>
    <v-flex lg4 xs12>
      <v-text-field v-model="mainForm.grossSI" :label="labels.grossSI" readonly reverse :loading="loading"></v-text-field>
    </v-flex>
    <v-flex lg3 xs12> </v-flex>

    <v-flex lg3 xs12> </v-flex>
    <v-flex lg2 xs12>
      <v-text-field v-model="mainForm.statPer" :label="labels.statPer" readonly reverse :loading="loading"></v-text-field>
    </v-flex>
    <v-flex lg4 xs12>
      <v-text-field v-model="mainForm.statSI" :label="labels.statSI" readonly reverse :loading="loading"></v-text-field>
    </v-flex>
    <v-flex lg3 xs12> </v-flex>

    <v-flex lg3 xs12> </v-flex>
    <v-flex lg2 xs12>
      <v-text-field v-model="mainForm.facPer" :label="labels.facPer" readonly reverse :loading="loading"></v-text-field>
    </v-flex>
    <v-flex lg4 xs12>
      <v-text-field v-model="mainForm.facSI" :label="labels.facSI" readonly reverse :loading="loading"></v-text-field>
    </v-flex>
    <v-flex lg3 xs12> </v-flex>

    <v-flex lg3 xs12> </v-flex>
    <v-flex lg2 xs12>
      <v-text-field v-model="mainForm.ttyPer" :label="labels.ttyPer" readonly reverse :loading="loading"></v-text-field>
    </v-flex>
    <v-flex lg4 xs12>
      <v-text-field v-model="mainForm.ttySI" :label="labels.ttySI" readonly reverse :loading="loading"></v-text-field>
    </v-flex>
    <v-flex lg3 xs12> </v-flex>

    <v-flex lg3 xs12> </v-flex>
    <v-flex lg2 xs12>
      <v-text-field v-model="mainForm.grossRetPer" :label="labels.grossRetPer" readonly reverse :loading="loading"></v-text-field>
    </v-flex>
    <v-flex lg4 xs12>
      <v-text-field v-model="mainForm.grossRet" :label="labels.grossRet" readonly reverse :loading="loading"></v-text-field>
    </v-flex>
    <v-flex lg3 xs12> </v-flex>

    <v-flex lg3 xs12> </v-flex>
    <v-flex lg2 xs12>
      <v-text-field v-model="mainForm.qsPer" :label="labels.qsPer" readonly reverse :loading="loading"></v-text-field>
    </v-flex>
    <v-flex lg4 xs12>
      <v-text-field v-model="mainForm.qsSI" :label="labels.qsSI" readonly reverse :loading="loading"></v-text-field>
    </v-flex>
    <v-flex lg3 xs12> </v-flex>

    <v-flex lg3 xs12> </v-flex>
    <v-flex lg2 xs12>
      <v-text-field v-model="mainForm.netRetPer" :label="labels.netRetPer" readonly reverse :loading="loading"></v-text-field>
    </v-flex>
    <v-flex lg4 xs12>
      <v-text-field v-model="mainForm.netRet" :label="labels.netRet" readonly reverse :loading="loading"></v-text-field>
    </v-flex>
    <v-flex lg3 xs12> </v-flex>
  </v-layout>
</template>

<script>
import { expandURI } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'
import { formatPrice, formatPriceExt } from '@/utils/index'

export default {
  data() {
    return {
      labels: {
        title: 'Sum Insured Totals',
        grossSI: 'Gross Sum Insured',
        coinsPer: 'Coinsurance %',
        coinsSI: 'Coinsurance',
        statPer: 'Statutory %',
        statSI: 'Statutory',
        facPer: 'Facultative %',
        facSI: 'Facultative',
        ttyPer: 'Treaty %',
        ttySI: 'Treaty',
        grossRetPer: 'Gross Retention %',
        grossRet: 'Gross Retention',
        qsPer: 'Quota Share %',
        qsSI: 'Quota Share',
        netRet: 'Net Retention',
        netRetPer: 'Net Retention %'
      },
      mainForm: {
        grossSI: undefined,
        coinsPer: undefined,
        coinsSI: undefined,
        statPer: undefined,
        statSI: undefined,
        facPer: undefined,
        facSI: undefined,
        ttyPer: undefined,
        ttySI: undefined,
        grossRetPer: undefined,
        grossRet: undefined,
        qsPer: undefined,
        qsSI: undefined,
        netRet: undefined,
        netRetPer: undefined
      },
      loading: false
    }
  },
  computed: {
    polMaster() {
      return this.$store.state.underwriting.policy.polMaster
    }
  },
  methods: {
    async doInit() {
      this.getSumInsuredTotalsTotals()
    },
    async getSumInsuredTotalsTotals() {
      const apiUrl = this.$store.state.underwriting.policySummarySettings.menu.sumInsuredTotals
      if (apiUrl) {
        try {
          this.loading = true

          const expand = {
            polNo: this.polMaster.polNo,
            renCnt: this.polMaster.renCnt,
            endtCnt: this.polMaster.endtCnt
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))

          this.setSumInsuredTotals(result)
          this.loading = false
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    setSumInsuredTotals(result) {
      const { data } = result
      if (data) {
        this.labels.title = 'Sum Insured Totals (' + data.baseCurr + ')'
        this.mainForm.grossSI = formatPrice(data.grossSI)
        this.mainForm.coinsPer = formatPriceExt(data.coinsPer, 6)
        this.mainForm.coinsSI = formatPrice(data.coinsSI)
        this.mainForm.statPer = formatPriceExt(data.statPer, 6)
        this.mainForm.statSI = formatPrice(data.statSI)
        this.mainForm.facPer = formatPriceExt(data.facPer, 6)
        this.mainForm.facSI = formatPrice(data.facSI)
        this.mainForm.ttyPer = formatPriceExt(data.ttyPer, 6)
        this.mainForm.ttySI = formatPrice(data.ttySI)
        this.mainForm.grossRetPer = formatPriceExt(data.grossRetPer, 6)
        this.mainForm.grossRet = formatPrice(data.grossRet)
        this.mainForm.qsPer = formatPriceExt(data.qsPer, 6)
        this.mainForm.qsSI = formatPrice(data.qsSI)
        this.mainForm.netRet = formatPrice(data.netRet)
        this.mainForm.netRetPer = formatPriceExt(data.netRetPer, 6)
      }
    }
  },
  beforeMount() {
    if (this.$store.state.underwriting.policySummarySettings.init === 1) {
      this.doInit()
    }
  },
  mixins: [MessageMixin]
}
</script>

<style>
</style>
